import { render, staticRenderFns } from "./AppRadioList.vue?vue&type=template&id=72b0cdcc&scoped=true"
import script from "./AppRadioList.vue?vue&type=script&lang=js"
export * from "./AppRadioList.vue?vue&type=script&lang=js"
import style0 from "./AppRadioList.vue?vue&type=style&index=0&id=72b0cdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0cdcc",
  null
  
)

export default component.exports